import { TERMS_VERSION } from '@steward-app/steward-types';
import { createApiClient } from '../api/client';

/**
 * Records that this person accepted the current Terms of Service and Privacy Policy
 * (steward-app#2630). Call it ONLY from a click on a button that has
 * {@link TermsAcceptanceLine} beside it: the line is what the person agreed to.
 *
 * The façade stamps the time and keeps the first acceptance at a version, so a repeat is
 * harmless. A failure throws, and the caller must not go on to the create or join it was
 * guarding (the façade would refuse it anyway). It does not touch the cached `/me`: inside
 * the workspace shell call `acceptTerms` from `useWorkspace`, which refetches it; the
 * first-run flow refetches `/me` itself once the bootstrap lands.
 */
export async function recordTermsAcceptance(token: string): Promise<void> {
  await createApiClient(token).put('/me', { termsAcceptance: { version: TERMS_VERSION } });
}
